import ChartFeWrapper from './ChartFeWrapper';

export default ChartFeWrapper;
